var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-button",class:{ 'back-button--active': _vm.isActive },on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')},"submit":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfbd60c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackButton.vue
// module id = null
// module chunks = 